module.exports = __webpack_public_path__ + "static/media/type-journal-item.2c5c38d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/type-journal-item.svg
// module id = 465
// module chunks = 0